import { Routes } from '@angular/router';
import { RoleWorkspaceComponent } from './components/role-workspace.component';
import { SupportTicketWorkspaceComponent } from './components/support-ticket-workspace.component';
import { LogoutRouteComponent } from './components/logout-route.component';

export const securityRoutes: Routes = [
  {
    path: 'role-workspace/:key',
    component: RoleWorkspaceComponent,
    data: {
      permissions: ['SecurityModule.Roles:View']
    }
  },
  {
    path: 'support-ticket-workspace',
    component: SupportTicketWorkspaceComponent,
    data: {
      permissions: ['ConfigurationModule.SupportTicket:Edit']
    }
  },
  {
    path: 'logout',
    component: LogoutRouteComponent,
    data: {
      skipGuard: true
    }    
  }
];



// WEBPACK FOOTER //
// ./src/app/security/routes.config.ts